import { IRadioButton } from "types/gaiaComponents/radioButton";
import React from "react";

export const RadioButton = React.forwardRef<HTMLInputElement, IRadioButton>((props, ref) => {
    return (
        <label className={`display-inline-flex ga-radio-button ${props.isInvalid ? " ga-radio-button--invalid" : ""}`}>
            <input type="radio"
                   className="ga-radio-button__native"
                   name={props.name}
                   ref={ref}
                   id={props.radioId}
                   value={props.value}
                   checked={props.isChecked}
                   disabled={props.isDisabled}
                   tabIndex={props.tabIndex}
                   onChange={props.onChange} />
            <div className="ga-radio-button__marker"></div>
            <div className="ga-radio-button__label">
                {props.label}
                {props.labelDescription &&
                    <div className="pt-3" data-testId = "__tst_labelDescription"> {props.labelDescription}
                    </div>
                }
            </div>
        </label>
    )
});

RadioButton.displayName = 'RadioButton';
